import {
  LoginPage,
  SignUpPage,
  TeamPage,
  MemberApprovalsPage,
  PermissionsPage,
  TaskAssignPage,
  DatabaseSetupPage,
  UserManagementPage,
} from './pages';
import { USERS_PERMISSIONS } from './config/accessControl';

export const usersPublicRoutes = [
  { path: '/login', component: LoginPage },
  { path: '/signup', component: SignUpPage },
];

export const usersProtectedRoutes = [
  {
    path: 'user-management',
    component: UserManagementPage,
    requiredPermission: USERS_PERMISSIONS.APPROVE_MEMBERS,
  },
  // Legacy routes kept for backward compatibility
  { path: 'team', component: TeamPage, requiredPermission: USERS_PERMISSIONS.TEAM_VIEW },
  {
    path: 'member-approvals',
    component: MemberApprovalsPage,
    requiredPermission: USERS_PERMISSIONS.APPROVE_MEMBERS,
  },
  {
    path: 'permissions',
    component: PermissionsPage,
    requiredPermission: USERS_PERMISSIONS.MANAGE_PERMISSIONS,
  },
  {
    path: 'tasks/assign/:memberId',
    component: TaskAssignPage,
    requiredPermission: USERS_PERMISSIONS.TEAM_VIEW,
  },
  {
    path: 'database-setup',
    component: DatabaseSetupPage,
    requiredPermission: USERS_PERMISSIONS.MANAGE_PERMISSIONS,
  },
];
